import { useState } from "react";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, RefreshCw } from "lucide-react";

const Row = ({ label, ok, note, testid }) => (
  <div data-testid={testid} className="flex items-start gap-3 py-2">
    {ok ? <CheckCircle2 size={17} className="text-emerald-400 shrink-0 mt-0.5" /> : <XCircle size={17} className="text-red-400 shrink-0 mt-0.5" />}
    <div className="min-w-0">
      <p className="text-sm">{label}</p>
      {note && <p className="text-xs text-text-muted mt-0.5 break-words">{note}</p>}
    </div>
  </div>
);

export const StripeStatus = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    try { setS((await api.get("/admin/stripe-status")).data); } catch { setS({ error: true }); }
    setBusy(false);
  };
  const idNote = s?.identity && !s.identity.ok
    ? (s.identity.code === "identity_api_invalid_application" ? "Not switched on yet. Complete the application at dashboard.stripe.com/identity/application." : s.identity.message)
    : null;
  return (
    <div data-testid="stripe-status" className="rounded-3xl border border-white/8 bg-surface/60 p-6 mb-8">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] text-gold">Payments health</p>
          <p className="text-sm text-text-muted mt-1">{s?.mode ? `Stripe ${s.mode} mode` : "Check what Stripe has switched on for Velluto"}</p>
        </div>
        <button data-testid="stripe-status-check" onClick={check} disabled={busy}
          className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-gold/40 text-gold text-[11px] uppercase tracking-[0.15em] disabled:opacity-50">
          <RefreshCw size={13} className={busy ? "animate-spin" : ""} /> {busy ? "Checking…" : "Check Stripe"}
        </button>
      </div>
      {s && !s.error && (
        <div className="mt-4 border-t border-white/8 pt-3">
          <Row testid="stripe-status-identity" label="18+ ID verification (Stripe Identity)" ok={s.identity?.ok} note={idNote} />
          <Row testid="stripe-status-charges" label="Taking payments" ok={s.charges_enabled} note={s.account?.message} />
          <Row testid="stripe-status-payouts" label="Payouts to your bank" ok={s.payouts_enabled} />
        </div>
      )}
      {s?.error && <p className="text-sm text-red-300 mt-4">Couldn't reach Stripe. Try again.</p>}
    </div>
  );
};
